import { createApp } from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from './quasar-user-options';
import App from './App.vue';
import store from './js/store';
import router from './js/router';

createApp(App).use(Quasar, quasarUserOptions).use(store).use(router).mount('#app')
